module.exports = new __parcel__URL__("obverseCard.e719df2b.png").toString();